import { render, staticRenderFns } from "./InquiryStatusInquiryCheckValidAndCloseModal.vue?vue&type=template&id=2c29a960&scoped=true&"
import script from "./InquiryStatusInquiryCheckValidAndCloseModal.vue?vue&type=script&lang=js&"
export * from "./InquiryStatusInquiryCheckValidAndCloseModal.vue?vue&type=script&lang=js&"
import style0 from "./InquiryStatusInquiryCheckValidAndCloseModal.vue?vue&type=style&index=0&id=2c29a960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c29a960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VDivider,VRow,VToolbar})
